import './about.less';
import template from './about.html';
import { AboutController as controller } from './about.controller';

export const aboutComponent = {
  template,
  controller
};



/** WEBPACK FOOTER **
 ** ./client/app/components/about/about.component.js
 **/